import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.05 5.328a1 1 0 0 1-.07 1.413L10.18 12l5.8 5.26a1 1 0 1 1-1.343 1.48l-6.617-6a1 1 0 0 1 0-1.48l6.617-6a1 1 0 0 1 1.412.068Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowLeft;
